import AuthClient from 'lib/auth/client';
import { IAccessTokenResponse } from 'lib/auth/types';

const client = new AuthClient();

export const decodeJwt = () => client.decodeJwt();
export const flush = () => client.flush();
export const getAccessToken = () => client.getAccessToken();
export const getAccessTokenResponse = () => client.getAccessTokenResponse();
export const getAuthorizationUrl = () => client.getAuthorizationUrl();
export const getRefreshToken = () => client.getRefreshToken();
export const getUserName = () => client.getUserName();
export const isAuthorized = () => client.isAuthorized();
export const isTokenExpired = () => client.isTokenExpired();
export const fetchAccessTokenResponse = (code: string) => client.fetchAccessTokenResponse(code);
export const fetchUserAuthorization = () => client.fetchUserAuthorization();
export const fetchAuthorizationUrl = async () => client.fetchAuthorizationUrl();
export const setAuthorized = (authorized: boolean) => client.setAuthorized(authorized);
export const setAuthorizationUrl = (authorizationUrl: string) => client.setAuthorizationUrl(authorizationUrl);
export const setAccessTokenResponse = (accessTokenResponse: IAccessTokenResponse) =>
  client.setAccessTokenResponse(accessTokenResponse);
export const getTokenPayload = () => client.getTokenPayload();
export const isAuthorizedUserAdmin = () => client.isAuthorizedUserAdmin();
